// global.js
// 根据环境变量自动切换接口地址
// 开发环境: .env          -> VUE_APP_BASE_API
// 测试环境: .env.test     -> VUE_APP_BASE_API
// 正式环境: .env.production -> VUE_APP_BASE_API
export default {
    base_url: process.env.VUE_APP_BASE_API || '/api',
    preview_path_url: process.env.VUE_APP_PREVIEW_URL || '/images/',
}

